import { EntityRegistry } from '@repo/core'
import type { EntityDefinition } from '@repo/core'
import type { ClientCompany } from './ledgersync.schema'

export const LedgerSyncEntity: EntityDefinition<ClientCompany> = {
  name: 'ledgersync',
  ui: {
    label: 'Client Vault',
    labelPlural: 'Client Vaults',
    icon: 'Briefcase',
    routePath: 'ledgersync/vaults',
    navGroup: 'LedgerSync',
    showInNav: true,
    navOrder: 2,
  },
  sync: { enabled: true, conflictStrategy: 'lww', priority: 'normal' },
  audit: { enabled: true },
  rbac: { enabled: true, permissionPrefix: 'ledgersync' },
  hooks: {},
  pagination: 'cursor',
  tenant: { enabled: true },
  softDelete: { enabled: true },
}

EntityRegistry.register(LedgerSyncEntity)
